import { CloseAllModalsEvent } from './../../events/close-all-modals-event';
import { MessagingService } from './../../events/messaging-service';
import { UserType } from './../../model/user-type';
import { Injectable } from '@angular/core';
import { JwtHelperService } from '@auth0/angular-jwt';
import { environment } from '../../../../environments/environment';
import { EndpointType } from '../../model/endpoint-type';
import { Router } from '@angular/router';

@Injectable()
export class AuthService {
  private jwtHelper: JwtHelperService;
  private endpointType: EndpointType;
  private authMethod: String;

  constructor(
    private router: Router,
    private messagingService: MessagingService) {
    this.jwtHelper = new JwtHelperService();
  }

  public isAuthenticated(): boolean {
    const token = sessionStorage.getItem('token');

    this.endpointType = sessionStorage.getItem('endpointType')
    === EndpointType.ENTERPRISE.toString() ? EndpointType.ENTERPRISE : EndpointType.SERVICEPROVIDER;
    if (this.endpointType === EndpointType.SERVICEPROVIDER) {
      this.authMethod = environment.serviceProviderEndpointAuthMethod;
    } else {
      this.authMethod = environment.enterpriseAccountEndpointAuthMethod;
    }

    // Check whether the token is expired and return
    // true or false
    if (this.authMethod === 'jwt') {
      return !this.jwtHelper.isTokenExpired(token);
    } else {
      return token != null && token !== '';
    }
  }

  public logout() {
    sessionStorage.removeItem('token');
    const userType = UserType[sessionStorage.getItem('userType')];
    let urlAppendix = '';
    if (userType === UserType.SERVICEPROVIDER_USER) {
      urlAppendix = '/admin';
    }
    this.router.navigate(['/login' + urlAppendix]);
    // close all modals
    this.closeAllModals();
  }
  private closeAllModals() {
    this.messagingService.publish(new CloseAllModalsEvent());
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/auth/auth.service.ts